import InformationBanner from './InformationBanner';
import { EmploymentDateInputForm, EmploymentSalaryInputForm } from './EmploymentInputs';
import { useForm } from 'react-hook-form';
import Icon from '@mdi/react';
import { mdiFileDocumentEditOutline } from '@mdi/js';
import { useGetEmploymentTypes } from '@my-pages/features/employment/hooks/queries.ts';
import { IEmploymentInfo } from '@shared/integrations/taf-api/v2/models';
import { formatDate, getStartOfNextMonth } from '@shared/utils/dateUtils.ts';
import useEmploymentFormActions from '@my-pages/features/employment/hooks/useEmploymentFormActions.ts';
import { useGetPerson } from '@my-pages/hooks/useGetPerson.ts';
import {employmentType} from "@my-pages/features/employment/services/EmploymentService.ts";
import { EmploymentUpdateStatus } from '@my-pages/features/employment/types';

interface IUnemploymentForm {
    employment: IEmploymentInfo;
    closeForm: () => void;
    setDisplayMessage: (value: EmploymentUpdateStatus | null) => void;
}

export const UnemploymentForm = ({ employment, closeForm, setDisplayMessage }: IUnemploymentForm) => {
    const { updateEmployment } = useEmploymentFormActions();
    const person = useGetPerson();
    const getEmploymentTypes = useGetEmploymentTypes();

    const {
        handleSubmit,
        register,
        control,
        formState: { isValid },
    } = useForm({ mode: 'onChange' });

    const submit = async (submitData: any) => {
        const submitDataWithDefaultData = {
            ...submitData,
            //description: UnemploymentDescription(submitData, employment),
            salary: Number(submitData.salary),
            employmentId: employment?.employmentId,
            startDateUnemployed: formatDate(submitData.startDateUnemployed),
            //@ts-ignore
            employementStatusId: getEmploymentTypes?.employmentTypes?.[employmentType.unemployed] || '',

            memberId: person.id,
            workplaceId: employment?.workplaceId,
        };
        const result = await updateEmployment(submitDataWithDefaultData);
        setDisplayMessage(result);
        closeForm();
    };
    return (
        <form onSubmit={handleSubmit(submit)}>
            <h3 className='d-flex'>
                <Icon
                    path={mdiFileDocumentEditOutline}
                    className='mdi mdi-36 mr-2 mt-n2'
                />
                <span>Har du blivit arbetslös?</span>
            </h3>
            <p className='required-info'>* Obligatoriska uppgifter</p>
            <EmploymentSalaryInputForm
                name={'salary'}
                register={{ ...register('salary', { required: true }) }}
            />
            <h4 className='mt-5'>Från vilken månad gäller dessa uppgifter?</h4>
            <EmploymentDateInputForm
                control={control}
                rules={{ required: true }}
                minDate={getStartOfNextMonth()}
                name={'startDateUnemployed'}
            />
            <InformationBanner />
            <div className='d-flex justify-content-sm-end mt-5 mb-4'>
                <button
                    className='btn btn-light btn-lg mr-3'
                    type='button'
                    onClick={() => closeForm()}
                >
                    Avbryt
                </button>
                <button
                    className='btn btn-primary btn-lg'
                    disabled={!isValid}
                >
                    Spara
                </button>
            </div>
        </form>
    );
};
